"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

var _Heading = _interopRequireDefault(require("../../../text/Heading5"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Contained = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1mnrtif-0"
})(["background-color:", ";border:1px solid ", ";padding:", "px;"], (0, _pclnDesignSystem.getPaletteColor)('background.light'), (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _themeGet.themeGet)('space.3'));
var PhoneNumber = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1mnrtif-1"
})(["margin-top:", "px;", "{margin-top:0;}"], (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('mediaQueries.md'));

var PartnerFusionPhoneNumber = function PartnerFusionPhoneNumber(_ref) {
  var className = _ref.className,
      contained = _ref.contained,
      phoneNumber = _ref.phoneNumber,
      onClick = _ref.onClick;
  var Container = contained ? Contained : _pclnDesignSystem.Flex;
  return phoneNumber && _react["default"].createElement(Container, {
    className: className,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    wrap: true,
    onClick: onClick
  }, _react["default"].createElement(_Heading["default"], {
    color: "secondary",
    mr: 1,
    bold: true
  }, "Special discount"), _react["default"].createElement(_Heading["default"], {
    mr: 2,
    bold: true
  }, "when you book by phone:"), _react["default"].createElement(PhoneNumber, null, _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: "phone",
    mr: 2
  }), _react["default"].createElement(_Heading["default"], {
    bold: true
  }, "Call ", phoneNumber)));
};

PartnerFusionPhoneNumber.displayName = 'PartnerFusionPhoneNumber';
PartnerFusionPhoneNumber.propTypes = {
  className: _propTypes["default"].string,
  contained: _propTypes["default"].bool,
  phoneNumber: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
PartnerFusionPhoneNumber.defaultProps = {
  className: '',
  contained: false,
  onClick: function onClick() {
    return null;
  }
};
var _default = PartnerFusionPhoneNumber;
exports["default"] = _default;